import React, { useState, useEffect } from 'react';
import {
  Briefcase,
  Users,
  MapPin,
  ShieldCheck,
  Handshake,
  Building2,
} from 'lucide-react';
import AboutImg from '../../Files/about-page-main-image-first-brick.png';
import TestimonialSection from '../TestimonialSection';

const AnimatedCounter = ({
  target,
  label,
}: {
  target: number;
  label: string;
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const step = Math.ceil(target / (duration / 16));

    const interval = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(interval);
      } else {
        setCount(start);
      }
    }, 16);

    return () => clearInterval(interval);
  }, [target]);

  return (
    <div className="about-page-fb-counter">
      <h3>{count}+</h3>
      <p>{label}</p>
    </div>
  );
};

const AboutUs = () => {
  return (
    <section className="about-page-fb">
      {/* Header */}
      <div className="about-page-fb-header">
        <h1>About Sarfare Properties </h1>
        <p>
          Your trusted partner in real estate with over 18 years of expertise.
        </p>
      </div>

      {/* Hero Image */}
      <div className="about-page-fb-hero-image">
        <img src={AboutImg} alt="Office or Property View" />
      </div>

      {/* Main Content Sections */}
      <div className="about-page-fb-main">
        <div className="about-page-fb-content">
          {/* Company Overview */}
          <div className="about-page-fb-section black-section">
            <h2>
              <Building2 size={22} /> Company Overview
            </h2>
            <p>
              Sarfare Properties is a trusted name in Mumbai’s real estate landscape, backed by over 20 years of industry experience in broking, investment consulting, and full-spectrum property services. We specialize in delivering high-value real estate solutions with a personal touch, helping both residents and NRIs navigate the complexities of the property market with confidence and ease.
            </p>
            <p>
              Our deep-rooted presence in Mumbai gives us unmatched insight into the city’s dynamic real estate trends. Whether you’re looking to buy, sell, invest, or manage property, our team is committed to maximizing your returns through tailored, transparent, and strategic guidance.
            </p>
            <p>
              At Sarfare Properties, our mission is simple: to offer reliable, end-to-end real estate services that prioritize your financial goals and peace of mind. With integrity at our core and client success as our driving force, we build long-term relationships that go beyond transactions.
            </p>
            <p>
              Let’s build your real estate journey — with experience, trust, and results that speak for themselves.
            </p>
          </div>

          {/* Mission */}
          <div className="about-page-fb-section gold-section">
            <h2>
              <Handshake size={22} /> Our Mission
            </h2>
            <p>
              To empower clients with market knowledge, ethical guidance, and
              full-service support — ensuring confident decisions in real
              estate.
            </p>
            <p>
              We aim to simplify the often complex and emotionally charged
              process of buying or selling a property.
            </p>
          </div>

          {/* Core Values */}
          <div className="about-page-fb-section black-section">
            <h2>
              <ShieldCheck size={22} /> Core Values
            </h2>
            <ul>
              <li>
                <ShieldCheck size={18} /> Integrity – We believe in doing what’s
                right, not what’s easy.
              </li>
              <li>
                <Briefcase size={18} /> Expertise – We stay ahead with market
                trends and strategies.
              </li>
              <li>
                <Users size={18} /> Client-Centricity – Your goals become our
                roadmap.
              </li>
            </ul>
            <p>
              These values define our operations, our culture, and the trust we
              build with every client.
            </p>
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="about-page-fb-trust-badges">
        <h2 className="about-page-fb-trust-heading">
          Why Clients Trust Sarfare Properties
        </h2>
        <div className="about-page-fb-badges-grid">
          <div className="about-page-fb-badge">
            <ShieldCheck size={28} />
            <p>Verified Properties</p>
          </div>
          <div className="about-page-fb-badge">
            <Handshake size={28} />
            <p>End-to-End Support</p>
          </div>
          <div className="about-page-fb-badge">
            <Users size={28} />
            <p>2,500+ Happy Clients</p>
          </div>
          <div className="about-page-fb-badge">
            <Briefcase size={28} />
            <p>18+ Years Expertise</p>
          </div>
        </div>
      </div>

      {/* Counters */}
      <div className="about-page-fb-counters">
        <AnimatedCounter target={2500} label="Happy Clients" />
        <AnimatedCounter target={150} label="Properties Sold" />
        <AnimatedCounter target={12} label="Operational Locations" />
      </div>

      {/* Founder Quote */}
      <div className="about-page-fb-founder-quote">
        <blockquote>
          <p>
            "At Sarfare Properties, we believe in not just helping you find a property,
            but in finding your future investment with confidence."
          </p>
          <footer>
            <cite>- Sarfare Properties</cite>
          </footer>
        </blockquote>
      </div>

      {/* <TestimonialSection /> */}
    </section>
  );
};

export default AboutUs;
